import React from "react";

const subText = { color: "#aab7ca", fontSize: 13, marginTop: 4 };

const PartnersMockup = () => (
  <div className="mk-candidate-card">
    <div className="mk-candidate-head">
      <div className="mk-profile-icon" aria-hidden="true" style={{ fontSize: 22 }}>AO</div>
      <div className="mk-profile-meta">
        <b>Tech Lead Asset Mgmt</b>
        <span>Appel d'offres · 6 mois · Paris · 650€ TJM</span>
      </div>
    </div>
    <div className="mk-hero-list">
      <section className="mk-hero-line">
        <div className="mk-hero-line-icon">DI</div>
        <div>
          <h3>Diffusé à 12 partenaires</h3>
          <div className="mk-search-item">
            <div><b>Talentor Consulting</b><br /><small>Diffusion · Tech BFI</small></div>
            <span className="mk-pct">12 CV reçus</span>
          </div>
          <div className="mk-search-item">
            <div><b>DataSphere Partners</b><br /><small>Sous-traitance · Data</small></div>
            <span className="mk-pct">8 CV reçus</span>
          </div>
        </div>
      </section>
      <section className="mk-hero-line">
        <div className="mk-hero-line-icon mk-score-circle">76%</div>
        <div>
          <h3>47 CV qualifiés sur 62 reçus</h3>
          <div style={subText}>Tri IA par pertinence sur le besoin</div>
        </div>
      </section>
      <section className="mk-hero-line">
        <div className="mk-hero-line-icon">MA</div>
        <div>
          <h3>Marge projetée</h3>
          <div className="mk-bar-row">
            <span>TJM client</span>
            <span className="mk-bar"><i style={{ width: "100%" }} /></span>
            <span>650€</span>
          </div>
          <div className="mk-bar-row">
            <span>TJM partenaire</span>
            <span className="mk-bar"><i style={{ width: "68%" }} /></span>
            <span>442€</span>
          </div>
          <div className="mk-bar-row">
            <span>Marge</span>
            <span className="mk-bar"><i style={{ width: "32%" }} /></span>
            <span>32%</span>
          </div>
        </div>
      </section>
    </div>
  </div>
);

const ProfileMockup = () => (
  <div className="mk-candidate-card">
    <div className="mk-candidate-head">
      <div className="mk-profile-icon" aria-hidden="true" style={{ fontSize: 20 }}>RFP</div>
      <div className="mk-profile-meta">
        <b>Lead Data Engineer · GCP</b>
        <span>Appel d'offres · 12 mois · Lyon</span>
      </div>
    </div>
    <div className="mk-hero-list">
      <section className="mk-hero-line">
        <div className="mk-hero-line-icon">SO</div>
        <div>
          <h3>Sourcing multi-sources</h3>
          <div style={subText}>324 profils identifiés via People Data Labs</div>
        </div>
      </section>
      <section className="mk-hero-line">
        <div className="mk-hero-line-icon mk-score-circle">94%</div>
        <div>
          <h3>Shortlist par pertinence</h3>
          <div className="mk-search-item">
            <div><b>Claire Dubois</b><br /><small>Lead Data · GCP · BigQuery</small></div>
            <span className="mk-pct">94%</span>
          </div>
          <div className="mk-search-item">
            <div><b>Marc Lévy</b><br /><small>Senior Data · GCP · Spark</small></div>
            <span className="mk-pct">89%</span>
          </div>
        </div>
      </section>
      <section className="mk-hero-line">
        <div className="mk-hero-line-icon">EX</div>
        <div>
          <h3>Export vers ASAP CV</h3>
          <div style={subText}>Dossiers de compétences générés en 1 clic</div>
        </div>
      </section>
    </div>
  </div>
);

const SkillsMockup = () => (
  <div className="mk-candidate-card">
    <div className="mk-candidate-head">
      <div className="mk-profile-icon" aria-hidden="true">JD</div>
      <div className="mk-profile-meta">
        <b>Julien Durand</b>
        <span>Évaluation Senior Backend Python · 42 min</span>
      </div>
    </div>
    <div className="mk-hero-list">
      <section className="mk-hero-line">
        <div className="mk-hero-line-icon mk-score-circle">82%</div>
        <div>
          <h3>Score global d'évaluation</h3>
          <div style={subText}>Niveau Senior confirmé · Rapport prêt</div>
        </div>
      </section>
      <section className="mk-hero-line">
        <div className="mk-hero-line-icon">SK</div>
        <div>
          <h3>Détail par compétence</h3>
          <div className="mk-bar-row">
            <span>Python</span>
            <span className="mk-bar"><i style={{ width: "89%" }} /></span>
            <span>89%</span>
          </div>
          <div className="mk-bar-row">
            <span>API REST</span>
            <span className="mk-bar"><i style={{ width: "78%" }} /></span>
            <span>78%</span>
          </div>
          <div className="mk-bar-row">
            <span>Tests unitaires</span>
            <span className="mk-bar"><i style={{ width: "65%" }} /></span>
            <span>65%</span>
          </div>
        </div>
      </section>
      <section className="mk-hero-line">
        <div className="mk-hero-line-icon">AT</div>
        <div>
          <h3>Anti-triche</h3>
          <div style={subText}>Environnement verrouillé · 0 alerte détectée</div>
        </div>
      </section>
    </div>
  </div>
);

const kpiTile = {
  flex: 1,
  padding: "10px 12px",
  borderRadius: 14,
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.07)",
};

const PilotMockup = () => (
  <div className="mk-candidate-card">
    <div className="mk-candidate-head">
      <div className="mk-profile-icon" aria-hidden="true">BU</div>
      <div className="mk-profile-meta">
        <b>Business Unit Tech</b>
        <span>Pilotage activité · Janvier 2026</span>
      </div>
    </div>
    <div className="mk-hero-list">
      <section className="mk-hero-line">
        <div className="mk-hero-line-icon">KP</div>
        <div>
          <h3>Indicateurs clés</h3>
          <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
            <div style={kpiTile}>
              <b style={{ display: "block", color: "#79f5c7", fontSize: 18, lineHeight: 1.1 }}>1,2M€</b>
              <small style={{ color: "#aab7ca", fontSize: 11 }}>Pipeline</small>
            </div>
            <div style={kpiTile}>
              <b style={{ display: "block", color: "#79f5c7", fontSize: 18, lineHeight: 1.1 }}>87%</b>
              <small style={{ color: "#aab7ca", fontSize: 11 }}>Activation</small>
            </div>
            <div style={kpiTile}>
              <b style={{ display: "block", color: "#79f5c7", fontSize: 18, lineHeight: 1.1 }}>34%</b>
              <small style={{ color: "#aab7ca", fontSize: 11 }}>Marge moy.</small>
            </div>
          </div>
        </div>
      </section>
      <section className="mk-hero-line">
        <div className="mk-hero-line-icon mk-score-circle">93%</div>
        <div>
          <h3>Matching · Besoin Tech Lead BNP</h3>
          <div className="mk-search-item">
            <div><b>Sophie Martin</b><br /><small>Senior Python · Dispo 15/02</small></div>
            <span className="mk-pct">93%</span>
          </div>
          <div className="mk-search-item">
            <div><b>Yanis Bernard</b><br /><small>Lead Backend · Inter-contrat</small></div>
            <span className="mk-pct">87%</span>
          </div>
        </div>
      </section>
      <section className="mk-hero-line">
        <div className="mk-hero-line-icon">ST</div>
        <div>
          <h3>Staffing en cours</h3>
          <div style={subText}>24 consultants en mission · 6 inter-contrats · 12 besoins ouverts</div>
        </div>
      </section>
    </div>
  </div>
);

const CvMockup = () => (
  <div className="mk-candidate-card">
    <div className="mk-candidate-head">
      <div className="mk-profile-icon" aria-hidden="true">ML</div>
      <div className="mk-profile-meta">
        <b>Marie Lefèvre</b>
        <span>Dossier de compétences · Senior Python · 8 ans</span>
      </div>
    </div>
    <div className="mk-hero-list">
      <section className="mk-hero-line">
        <div className="mk-hero-line-icon">CV</div>
        <div>
          <h3>CV source analysé</h3>
          <div className="mk-search-item">
            <div><b>cv_marie_lefevre.pdf</b><br /><small>3 pages · Importé en DOCX</small></div>
            <span className="mk-pct">1m 47s</span>
          </div>
        </div>
      </section>
      <section className="mk-hero-line">
        <div className="mk-hero-line-icon">SK</div>
        <div>
          <h3>Compétences extraites par IA</h3>
          <div className="mk-bar-row">
            <span>Python</span>
            <span className="mk-bar"><i style={{ width: "92%" }} /></span>
            <span>92%</span>
          </div>
          <div className="mk-bar-row">
            <span>Django</span>
            <span className="mk-bar"><i style={{ width: "84%" }} /></span>
            <span>84%</span>
          </div>
          <div className="mk-bar-row">
            <span>AWS</span>
            <span className="mk-bar"><i style={{ width: "71%" }} /></span>
            <span>71%</span>
          </div>
        </div>
      </section>
      <section className="mk-hero-line">
        <div className="mk-hero-line-icon">TPL</div>
        <div>
          <h3>Dossier généré au format ESN</h3>
          <div style={subText}>Charte appliquée · 6 sections · FR ↔ EN</div>
        </div>
      </section>
    </div>
  </div>
);

const MOCKUPS = {
  partners: PartnersMockup,
  profile: ProfileMockup,
  skills: SkillsMockup,
  pilot: PilotMockup,
  cv: CvMockup,
};

const ModuleHeroMockup = ({ moduleKey }) => {
  const Mockup = MOCKUPS[moduleKey];
  if (!Mockup) return null;
  return <Mockup />;
};

export default ModuleHeroMockup;
